import React from "react";  

import {  
    
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import DashboardFormsPaycheckAdd from "components/Dashboard/Forms/PaycheckAdd";

export default function DashboardFormPaycheckAdd(){  

    const history = useHistory(); 
    const navigate = to => history.push(`/${ to }`); 

    return ( 
        <>
            <ContainerAuthenticated page={"paycheck"}> 
                <Row> 
                    <Col sm={12} md={12}>
                        <DashboardFormsPaycheckAdd />
                    </Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}